import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Any } from 'src/app/shared/models/signature.model';
import { ToastBehaviorService } from 'src/app/services/behavior/toast-behavior.service';
import { SignatureService } from 'src/app/services/signature-service/signature.service';

declare var $:any;

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {

  email!: string;
  name!: string;
  type!: string;
  file!: any;
  pdfSrc!: any;
  btnViewFile: boolean = false;
  btnViewMore: boolean = false;
  spin: boolean = false;
  disabled: string = '';

  constructor(
    private readonly signatureService: SignatureService,
    private readonly toast: ToastBehaviorService
  ) { }

  @ViewChild('input')
  input!: ElementRef;

  handleFileInput( targent: any ) {
    var reader = new FileReader();
    if(targent.files){
      const file = targent.files[0];
      this.type = file.type
      this.name = file.name
      reader.addEventListener('load', () => {
        this.file = reader.result
        this.btnViewFile = true
      })
      reader.readAsDataURL(file)
    }
  }

  getFile(){
    if(this.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    this.type === 'application/msword'){
      this.btnViewMore = false
      this.signatureService.postConverter(this.file, this.type).subscribe((res:Any) => {
        this.pdfSrc = `data:application/pdf;base64,${res.dto}`;
      })
    } else {
      this.pdfSrc = this.file
    }
  }
  
  upload(){
    this.spin = true;
    this.disabled = 'disabled';
    this.signatureService.postUploadFile(this.file, this.name, this.type).subscribe(res => {
      this.pdfSrc = undefined
      this.input.nativeElement.value = "";
      this.toast.set('', 'File uploaded successfully.', 'bg-success')
      this.spin = false;
      this.disabled = '';
    }, error => {
      this.disabled = '';
      this.spin = false;
    })
  }

  ngOnInit(): void {
  }

}
